module.exports = __webpack_public_path__ + "static/media/story_03.a2e354f5.jpg";